// mejora-web F4: biblioteca de vídeos (práctica + grabaciones de clases online).
import { useState, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useVideos, VideoCard, ReproductorModal } from '../components/VideosComunes';

const TIPOS = ['todos', 'practica', 'grabacion_clase'];

export default function Videos() {
  const { t, i18n } = useTranslation();
  const { isAuthenticated } = useAuth();
  const lang = (i18n.resolvedLanguage || 'es').toLowerCase();
  const { data, membresia, error } = useVideos(lang);
  const [tipo, setTipo] = useState('todos');
  const [reproduciendo, setReproduciendo] = useState(null);
  const [aviso, setAviso] = useState(false);
  const cerrar = useCallback(() => setReproduciendo(null), []);

  const lista = useMemo(() => (data || []).filter((v) =>
    (tipo === 'todos' || v.tipo === tipo)), [data, tipo]);

  return (
    <main className="videos-page">
      <header className="horarios-head">
        <span className="section-eyebrow">{t('videos.eyebrow')}</span>
        <h1 className="horarios-titulo">{t('videos.page_titulo')}</h1>
        <p className="horarios-sub">{membresia ? t('videos.page_sub_miembro') : t('videos.page_sub')}</p>
      </header>

      {!membresia && data && data.some((v) => v.bloqueado) && (
        <BannerMembresia logueado={isAuthenticated} resaltar={aviso} />
      )}

      <div className="videos-controles">
        <div className="filtro-segmento" role="group" aria-label={t('videos.tipo_label')}>
          {TIPOS.map((x) => (
            <button key={x} type="button" className={'filtro-seg-btn' + (tipo === x ? ' active' : '')} onClick={() => setTipo(x)}>
              {t(`videos.tipo.${x}`)}
            </button>
          ))}
        </div>
      </div>

      {error ? (
        <div className="horarios-error">{t('videos.error')}</div>
      ) : data === null ? (
        <div className="videos-grid">{[0, 1, 2, 3].map((i) => <div key={i} className="video-card video-skel" />)}</div>
      ) : lista.length === 0 ? (
        <p className="horarios-vacio">{t('videos.vacio')}</p>
      ) : (
        <div className="videos-grid">
          {lista.map((v) => (
            <VideoCard key={v.id} video={v} onPlay={setReproduciendo} onBloqueado={() => { setAviso(true); window.scrollTo({ top: 0, behavior: 'smooth' }); }} />
          ))}
        </div>
      )}
      {reproduciendo && <ReproductorModal video={reproduciendo} onClose={cerrar} />}
    </main>
  );
}

export function BannerMembresia({ logueado, resaltar = false, compacto = false }) {
  const { t } = useTranslation();
  return (
    <div className={'banner-membresia' + (resaltar ? ' is-resaltado' : '') + (compacto ? ' is-compacto' : '')}>
      <Lock size={20} strokeWidth={1.5} />
      <div className="banner-membresia-texto">
        <strong>{t('videos.banner_titulo')}</strong>
        <span>{t('videos.banner_texto')}</span>
      </div>
      <div className="banner-membresia-acciones">
        <a href="/#bonos" className="btn-primary">{t('videos.banner_cta')}</a>
        {!logueado && <Link to="/login?next=%2Fvideos" className="banner-membresia-login">{t('videos.banner_login')}</Link>}
      </div>
    </div>
  );
}
